import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Center,
  Flex,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Heading,
  Image,
  Input,
  Stack,
  Text,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import { FiKey } from 'react-icons/fi';
import { ChangePasswordForm, useChangePasswordForm } from './hooks/userChangePasswordForm';
import { useLocation } from 'react-router-dom';
import api from '../../services/api';
import { JwtService } from '../../services/jwtService';
import { Toast } from '../../components/Toast';
import { CiWarning } from 'react-icons/ci';
import { AxiosError } from 'axios';
import { SuccessModal } from './components/SuccessModal';

export const ChangePassword = () => {
  const { controls, handleSubmit, errors } = useChangePasswordForm();
  const location = useLocation();
  const { isOpen, onClose, onOpen } = useDisclosure();
  const toast = useToast();
  const [uriToken, setUriToken] = useState('');

  useEffect(() => {
    const token = location.search.split('token=')[1];

    if (!token) {
      window.location.href = '/';
    }

    setUriToken(token);
  }, []);

  const submit = async (data: ChangePasswordForm) => {
    try {
      const response = await api.put('/password-recovery/change-password', {
        password: data.newPassword,
      }, {
        headers: {
          Authorization: `Bearer ${uriToken}`,
        }
      });
      if (response.status === 201) {
        onOpen()
      }
    } catch (e) {
      if (e instanceof AxiosError && e.status === 400) {
        const message = 'La contraseña no debe coincidir con las anteriores';
        const ref = toast({
          position: 'bottom-right',
          render: () => (<Toast message={message} icon={<CiWarning />} onClose={() => toast.close(ref)} />),
        });
      }
    }
  };

  return (
    <Center height="100vh">
      <SuccessModal isOpen={isOpen} onClose={onClose} />
      <Stack>
        <Image src="/logo.png" alt="logo" width="6em" marginBottom="xl" />
        <Stack padding="xxxl" borderRadius="xl" border="1px" borderColor="gray.300" maxWidth="30em">
          <Center marginY="xl">
            <Box borderRadius="full" padding="l" backgroundColor="primary.800" width="fit-content">
              <FiKey fontSize="1.5em" color="white" />
            </Box>
          </Center>
          <Heading as="h1" fontSize="xxl" fontWeight="bold" marginBottom="xl">Nueva contraseña</Heading>
          <Text marginBottom="xxl">Tu nueva contraseña debe ser diferente a la contraseña anterior.</Text>

          <FormControl marginBottom="xl" isInvalid={!!errors.newPassword}>
            <FormLabel>Nueva contraseña</FormLabel>
            <Input type="password" placeholder="****************" {...controls.newPassword} />
            <FormErrorMessage>{errors.newPassword?.message}</FormErrorMessage>
            <FormHelperText fontSize="s" color="grey.700">Mínimo 8 caracteres, una mayúscula y un
              número.</FormHelperText>
          </FormControl>
          <FormControl isInvalid={!!errors.confirmPassword}>
            <FormLabel>Repetir nueva contraseña</FormLabel>
            <Input type="password" placeholder="****************" {...controls.confirmPassword} />
            <FormErrorMessage>{errors.confirmPassword?.message}</FormErrorMessage>
          </FormControl>

          <Flex justifyContent="space-between" alignItems="center" marginTop="xxl">
            <Button variant="ghost">Cancelar</Button>
            <Button colorScheme="button-primary" onClick={handleSubmit(submit)}>Crear nueva contraseña</Button>
          </Flex>
        </Stack>
      </Stack>
    </Center>
  );
};
